import React, { useState } from "react";
import { BASE_URL } from "./Config";

export default function ForgotPassword({ onClose }) {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [new_password, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);


  const sendOtp = async () => {
    setMessage("Sending OTP...");
    try {
      const res = await fetch(`${BASE_URL}/api/user/forgot_password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok) {
        setStep(2);
        setMessage("OTP sent to your email.");
      } else {
        setMessage(data.message || "Failed to send OTP.");
      }
    } catch(error) {
        console.error("Network error:", error);
        setMessage("❌ Network error.");
    }
  };
const verifyOtp = async () => {
  setMessage("Verifying OTP...");
  try {
    const res = await fetch("https://db85-2409-40c2-1055-a5f3-d1ec-6521-5cc3-ebb8.ngrok-free.app/api/user/verify_otp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, otp }),
    });
    const data = await res.json();
    if (res.ok) {
      setStep(3);
      setMessage("OTP verified. Set your new password.");
    } else {
      setMessage(data.message || "Invalid OTP.");
    }
  } catch {
    setMessage("❌ Network error.");
  }
};

  const resetPassword = async () => {
  setMessage("Resetting password...");
  try {
    const res = await fetch("https://db85-2409-40c2-1055-a5f3-d1ec-6521-5cc3-ebb8.ngrok-free.app/api/user/reset_password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, new_password }),
    });
    const data = await res.json();
    if (res.ok) {
      setMessage("✅ Password reset successfully!");
      setTimeout(onClose, 2000); // Closes modal after success
    } else {
      setMessage(data.message || "Failed to reset password.");
    }
  } catch {
    setMessage("❌ Network error.");
  }
};
<input
  type={showPassword ? "text" : "password"}
  placeholder="New Password"
  value={new_password}
  onChange={(e) => setNewPassword(e.target.value)}
  style={{ width: "100%", marginBottom: 10 }}
/>
  return (
    <div style={{ background: "#fff", padding: 20, borderRadius: 8, width: 300 }}>
      <h2>Forgot Password</h2>
      {step === 1 && (
        <>
          <input
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: "90%", marginBottom: 10 }}
            required
          />
          <button onClick={sendOtp} style={{ width: "100%" }}>
            Send OTP
          </button>
        </>
      )}

      {step === 2 && (
        <>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            style={{ width: "100%", marginBottom: 10 }}
          />
          <button onClick={verifyOtp} style={{ width: "100%" }}>
            Verify OTP
          </button>
        </>
      )}

      {step === 3 && (
        <>
          <input
            type="password"
            placeholder="New Password"
            value={new_password}
            onChange={(e) => setNewPassword(e.target.value)}
            style={{ width: "100%", marginBottom: 10 }}
          />
          <button onClick={resetPassword} style={{ width: "100%" }}>
            Set New Password
          </button>
        </>
      )}

      <p style={{ marginTop: 10 }}>{message}</p>
      <button onClick={onClose} style={{ marginTop: 10, width: "100%" }}>
        Cancel
      </button>
    </div>
  );
}
